import React from 'react';

interface ErrorMessages {
  [key: string]: React.ReactChild;
}
const mapErrorMessages: ErrorMessages = {
  'Request failed with status code 401': (
    <>
      <strong>Não autorizado</strong>: realizar o login
    </>
  ),
};

export const mapErrorMessage = (message: string): React.ReactChild => {
  return mapErrorMessages[message];
};
